import isUrl from 'is-url'
import { ELEMENT_TYPES, TOOLBAR_EXCLUDES } from 'cg/components/documents/editor/slate/types'
import { Transforms, Editor, Range, Element } from 'vendor/slate'

const isLinkActive = editor => {
  const [link] = Editor.nodes(editor, {
    match: n => !Editor.isEditor(n) && n.type === ELEMENT_TYPES.link
  })
  return !!link
}

const unwrapLink = editor => {
  Transforms.unwrapNodes(editor, { match: n => !Editor.isEditor(n) && n.type === ELEMENT_TYPES.link })
}

const wrapLink = (editor, url, targetBlank, title = null) => {
  if (isLinkActive(editor)) {
    unwrapLink(editor)
  }

  if (!editor.selection) Transforms.select(editor, editor.lastSelection)

  const { selection, lastSelection } = editor
  const isCollapsed = selection && Range.isCollapsed(selection)

  const link = {
    type: ELEMENT_TYPES.link,
    url,
    targetBlank,
    children: isCollapsed ? [{ text: title || url, parent: { type: ELEMENT_TYPES.link } }] : []
  }

  const [excludes] = Editor.nodes(editor, {
    at: selection || lastSelection,
    mode: 'lowest',
    match: n => !Editor.isEditor(n) && TOOLBAR_EXCLUDES.includes(n.parent && n.parent.type)
  })

  if (excludes) return

  if (isCollapsed) {
    if (!selection) Transforms.select(editor, lastSelection)
    Transforms.insertNodes(editor, link)
  } else {
    Transforms.wrapNodes(editor, link, {
      split: true
    })
    Transforms.collapse(editor, { edge: 'end' })
  }
}

const insertLink = (editor, url, targetBlank, title = null) => {
  if (editor.selection || editor.lastSelection) {
    wrapLink(editor, url, targetBlank, title)
  }
}

const withLink = editor => {
  const { insertData, insertText, isInline } = editor

  editor.isInline = element => (element.type === ELEMENT_TYPES.link ? true : isInline(element))

  editor.insertText = text => {
    if (text && isUrl(text)) {
      wrapLink(editor, text, true)
    } else {
      insertText(text)
    }
  }

  editor.insertData = data => {
    const text = data.getData('text/plain')

    if (text && isUrl(text)) {
      wrapLink(editor, text, true)
    } else {
      insertData(data)
    }
  }

  return editor
}

export { insertLink, isLinkActive, wrapLink, unwrapLink, withLink }
